'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'tree-city';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e587';
var svgPathData = 'M320 64l0 384c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-288c0-17.7-14.3-32-32-32l-80 0c-8.8 0-16-7.2-16-16l0-48c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32zM512 96l32 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-384c0-35.3 28.7-64 64-64l96 0c35.3 0 64 28.7 64 64l0 32zM388 88l24 0c6.6 0 12 5.4 12 12l0 24c0 6.6-5.4 12-12 12l-24 0c-6.6 0-12-5.4-12-12l0-24c0-6.6 5.4-12 12-12zM376 196c0-6.6 5.4-12 12-12l24 0c6.6 0 12 5.4 12 12l0 24c0 6.6-5.4 12-12 12l-24 0c-6.6 0-12-5.4-12-12l0-24zm12 84l24 0c6.6 0 12 5.4 12 12l0 24c0 6.6-5.4 12-12 12l-24 0c-6.6 0-12-5.4-12-12l0-24c0-6.6 5.4-12 12-12zm116-84c0-6.6 5.4-12 12-12l24 0c6.6 0 12 5.4 12 12l0 24c0 6.6-5.4 12-12 12l-24 0c-6.6 0-12-5.4-12-12l0-24zm12 84l24 0c6.6 0 12 5.4 12 12l0 24c0 6.6-5.4 12-12 12l-24 0c-6.6 0-12-5.4-12-12l0-24c0-6.6 5.4-12 12-12zM32 152C32 94.6 78.6 48 136 48S240 94.6 240 152l0 104c0 44.2-35.8 80-80 80l-16 0 0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160-16 0c-53 0-96-43-96-96 0-29 12.9-55 33.1-72.6-.8-5-1.1-10.2-1.1-15.4zM160 304c26.5 0 48-21.5 48-48l0-104c0-39.8-32.2-72-72-72s-72 32.2-72 72c0 6.2 .8 12.3 2.3 18 1.7 6.5-.9 13.4-6.4 17.2-16.8 11.6-27.8 30.9-27.8 52.8 0 35.3 28.7 64 64 64l16 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 16 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTreeCity = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;